module.exports = __webpack_public_path__ + "static/media/BT_logo.37367f82.zip";